import script from "./tourmatch-table.vue?vue&type=script&setup=true&lang=js"
export * from "./tourmatch-table.vue?vue&type=script&setup=true&lang=js"

import "./tourmatch-table.vue?vue&type=style&index=0&id=cd4bfe1e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4bfe1e"]])

export default __exports__